import React from "react";
import Images from "../data/Images";
import { Eye, Target } from "lucide-react";

const About = () => {
  return (
    <div className="text-gray-800">
      <div className="text-center bg-red-800 text-white py-16 border border-red-800">
        <h2 className="text-4xl font-bold mb-2">About Us</h2>
        <p className="text-lg font-medium">
          Canada's Fastest Growing Security Company
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12 text-center">
        <p className="text-xl leading-relaxed">
          Welcome to New Way Security, your trusted partner in ensuring
          unparalleled safety and security. As a prominent security consultancy
          company based in Canada, we take immense pride in our unwavering
          commitment to safeguarding your assets and providing comprehensive
          security solutions tailored to your unique needs.
        </p>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
        <div className="flex flex-col bg-red-50 p-8 rounded-2xl shadow-md">
          <div className="flex items-center mb-4">
            <Eye className="h-8 w-8 text-red-800 mr-3" />
            <h3 className="text-3xl font-semibold text-red-800">Our Vision</h3>
          </div>
          <p className="text-gray-700 text-lg leading-relaxed">
            To redefine the standards of security consultancy, setting new
            benchmarks in the industry. We aim to be the most trusted and
            reliable security partner by offering unmatched expertise and
            personalized solutions.
          </p>
        </div>

        <div className="flex flex-col bg-red-50 p-8 rounded-2xl shadow-md">
          <div className="flex items-center mb-4">
            <Target className="h-8 w-8 text-red-800 mr-3" />
            <h3 className="text-3xl font-semibold text-red-800">Our Mission</h3>
          </div>
          <p className="text-gray-700 text-lg leading-relaxed">
            To create a safer environment through cutting-edge technology and
            industry expertise. Our team is driven to ensure everyone feels
            secure with innovative solutions that exceed expectations.
          </p>
        </div>
      </div>

      <section className="border border-red-800 py-16">
  <div className="max-w-7xl mx-auto px-6">
    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold">
        Why Choose <span className="text-red-800">New Way Security?</span>
      </h2>
      <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
        In today’s fast-changing world, protecting your business, employees, and assets is more
        important than ever. Here’s why clients across industries trust us:
      </p>
    </div>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        {
          title: "Own Dedicated Software",
          text: "Unlike others, we operate with our own software and mobile apps for clients, guards, staff, and admin—ensuring transparency, efficiency, and real-time monitoring.",
          img: Images.Technology,
        },
        {
          title: "24/7 Surveillance & Monitoring",
          text: "Our guards and backend team provide constant monitoring with live video, photo updates, and rapid incident response available to clients anytime.",
          img: Images.hours,
        },
        {
          title: "On-Site Live Monitoring",
          text: "Guards record live videos and photos with timestamps. All footage is stored for 30 days and can be provided instantly upon client request.",
          img: Images.solve,
        },
        {
          title: "Trained & Licensed Guards",
          text: "We recruit only verified and licensed professionals trained in communication, emergency handling, and situational awareness for unmatched service.",
          img: Images.exp,
        },
        {
          title: "Customized Security Plans",
          text: "Every business is different. We design tailored security strategies based on your site needs, budget, and industry requirements.",
          img: Images.Technology,
        },
        {
          title: "Emergency Preparedness",
          text: "Our personnel are equipped to respond quickly to fire, medical, or unforeseen emergencies with the right tools and training.",
          img: Images.hours,
        },
        {
          title: "Technology Integration",
          text: "We combine CCTV, access control, and intrusion detection with our software platform for smarter, more reliable protection.",
          img: Images.solve,
        },
        {
          title: "Regular Performance Reviews",
          text: "Our guards and services are continuously evaluated to maintain the highest standards of client satisfaction and operational excellence.",
          img: Images.exp,
        },
        {
          title: "Customer-Centric Service",
          text: "Beyond protection, we focus on professionalism and hospitality—ensuring every interaction leaves a positive impression.",
          img: Images.Technology,
        },
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-start hover:shadow-xl transition-shadow"
        >
          <img src={item.img} alt={item.title} className="w-16 h-16 mb-4" />
          <h3 className="text-xl font-semibold text-red-800 mb-2">
            {item.title}
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed">{item.text}</p>
        </div>
      ))}
    </div>
  </div>
</section>
    </div>
  );
};

export default About;
